<template>
    <section class="featured-outfit-card-container">
        <featured-outfit-card
            :outfit="outfit"
            :handleProductClk="handleItemClick"
            :swapProductClk="
                (product) => $emit('swap-product', product, outfit)
            "
        >
            <template v-slot:footer-buttons>
                <div class="footer-buttons">
                    <share-outfit :outfit="outfit" />
                    <button class="footer-button" @click="shopItems">
                        Shop Items
                    </button>
                    <purchase-outfit-button
                        classes="footer-button footer-button--pink"
                        @click.stop="purchaseOutfit"
                        :outfit="outfit"
                    />
                </div>
            </template>
        </featured-outfit-card>
    </section>
</template>

<script>
import FeaturedOutfitCard from "../style-selection/outfit-card.vue";
import ShareOutfit from "../outfit/share-outfit.vue";
import PurchaseOutfitButton from "../outfit/purchase-outfit-button.vue";

import { OUTFIT_TYPES } from "../../config.js";

export default {
    props: {
        outfit: Object,
        index: Number,
    },
    components: {
        FeaturedOutfitCard,
        ShareOutfit,
        PurchaseOutfitButton,
    },
    methods: {
        handleItemClick(product, outfit) {
            this.setFeaturedReturnPageAndOutfit(outfit);
            this.$helpers.visitProduct(this.$router, product, {
                outfitId: outfit.outfit_id,
                outfitType: OUTFIT_TYPES.FEATURED,
            });
        },
        setFeaturedReturnPageAndOutfit(outfit) {
            this.$store.commit("menu/setReturnPage", {
                title: "Featured Outfits",
                href: "/shop",
            });
            this.$store.commit("outfits/setCurrentOutfit", {
                outfit,
                outfitType: OUTFIT_TYPES.FEATURED,
            });
        },
        purchaseOutfit() {
            this.setFeaturedReturnPageAndOutfit(this.outfit);
        },
        shopItems() {
            this.setFeaturedReturnPageAndOutfit(this.outfit);
            this.$emit("shop-items");
        },
    },
};
</script>

<style lang="scss">
.featured-outfit-card-container {
    margin: 24px 3vw;
    height: 530px;
}
.footer-buttons {
    background-color: white;
    flex-basis: 80px;
    padding: 20px 0;
    border-radius: 0 0px 20px 20px;
    display: flex;
    justify-content: space-evenly;
    .footer-button {
        border-radius: 23px;
        padding: 0px 13px;
        height: 46px;
        font-family: "Lato";
        font-size: 14px;
        background-color: #efefef;
        flex: 0.45;
        &--pink {
            background-color: #f2c0de;
            color: white;
        }
    }
}
.save-button-container {
    margin-top: 30px;
}
</style>
